<form [formGroup]="nContributionForm">
	<mat-form-field appearance="fill"
		class="mat-form-field--half-width">
		<mat-label>
			{{'Expected Irrigation Method' | translate }}
		</mat-label>
		<mat-select formControlName="IrrigationMethodId">
			<mat-option *ngFor="let irrigationMethod of this.irrigationMethods"
				[value]="irrigationMethod.Id">
				{{irrigationMethod.Name}}
			</mat-option>
		</mat-select>
	</mat-form-field>

	<div class="bk-n-contribution-ui__irrigation--loader" #nContributionIrrigationLoader>
		<div class="bk-n-contribution-ui__loader">
			<div class="bk-loader">
				{{'Loading' | translate }}...
			</div>
		</div>
	</div>

	<div class="bk-n-contribution-ui__irrigation--container" #nContributionIrrigation>

		<div class="bk-modal__radio-buttons bk-n-contribution-ui__radio-buttons">
			<mat-radio-group aria-label=""
				name="UseWells"
				formControlName="UseWells">

				<mat-radio-button [value]="true"
					(click)="calculateNContribution(true);"
					name="UseWells">
					<span *ngIf="fn.wells.value.length > 1">
						{{'Use Avg. Water Source PPM' | translate}}
					</span>
					<span *ngIf="fn.wells.value.length === 1">
						{{'Use Water Source PPM'}} ({{ NContribution.calculatedPPM | number: '1.0-2'}} ppm}
					</span>
				</mat-radio-button>

				<mat-radio-button [value]="false"
					class="mat-radio-button--left-margin"
					(click)="calculateNContribution(true);"
					name="UseWells">
					{{'Enter PPM Manually' | translate}}
				</mat-radio-button>
			</mat-radio-group>
		</div>

		<ng-container *ngIf="fn.UseWells.value && fn.wells.value.length > 1">
			<label class="bk-n-contribution-ui__label">
				{{ 'Blending of Water from Various Water Sources' | translate }}
			</label>

			<div *ngIf="!fn.wells.value.length === 0"
				class="bk-n-contribution-ui__invalid-text bk-n-contribution-ui__invalid-text--no-wells">
				{{ 'There are no water sources associated with this Planting' | translate }}
			</div>

			<table *ngIf="fn.wells.value.length"
				class="bk-n-contribution-ui__table">
				<thead class="bk-n-contribution-ui__table-head">
					<tr>
						<th class="bk-n-contribution-ui__table-head--border bk-n-contribution-ui__table-column--well">
							{{ 'Water Source' | translate }}
						</th>
						<th class="bk-n-contribution-ui__table-head--border bk-n-contribution-ui__table-column--ppm">
							{{ 'N Concentration' | translate }}
						</th>
						<th class="bk-n-contribution-ui__table-head--border bk-n-contribution-ui__table-column--percentage">
							{{ '% Used for Planting' | translate }}
						</th>
						<th class="bk-n-contribution-ui__table-column--error"></th>
					</tr>
				</thead>
				<tbody class="bk-n-contribution-ui__table-body">
					<tr *ngFor="let well of fn.wells.controls; let i = index">
						<td class="bk-n-contribution-ui__table-body--border">
							{{well.get('Name').value}}
						</td>
						<td class="bk-n-contribution-ui__table-body--border">
							{{well.get('NitrogenPPM').value}} ppm
						</td>
						<td class="bk-n-contribution-ui__table-body--border">
							<mat-form-field appearance="fill"
								class="mat-form-field--remove-label-space">
								<input matInput
									class="mat-input-element--text-align-right"
									type="number"
									step="0.01"
									[formControl]="fn.wells.controls[i].get('Percentage')"
									(blur)="calculateNContribution(true)"/>
								<span matSuffix class="mat-form-field-suffix--padded">%</span>
							</mat-form-field>
						</td>
						<td class="bk-n-contribution-ui__table-error">
						</td>
					</tr>
					<tr class="bk-n-contribution-ui__table-footer">
						<td class="bk-n-contribution-ui__table-footer--avg-text">
							{{ 'Average N Concentration' | translate }}
						</td>
						<td>
							<span *ngIf="NContribution.calculatedPPM || NContribution.calculatedPPM === 0">
								{{NContribution.calculatedPPM | number: '1.0-2'}} ppm
							</span>
							<span *ngIf="!NContribution.calculatedPPM && NContribution.calculatedPPM !== 0">
								N/A ppm
							</span>
						</td>
						<td>
							{{ totalWellPercentage }}%
						</td>
						<td class="bk-n-contribution-ui__table-error">
							<i *ngIf="totalWellPercentage !== 100"
								class="bk-n-contribution-ui__table-error--icon-invalid fa fa-times">
							</i>
							<i *ngIf="totalWellPercentage === 100"
								class="bk-n-contribution-ui__table-error--icon-valid fa fa-check"></i>
							<span *ngIf="totalWellPercentage !== 100"
								class="bk-n-contribution-ui__table-error--text">
								{{'Percentages must total 100' | translate}}.
								{{ 'You must'}} <ng-container *ngIf="totalWellPercentage < 100">{{'add' | translate }} <b>{{ 100 - totalWellPercentage}}%</b></ng-container>
								<ng-container *ngIf="totalWellPercentage > 100">{{'subtract' | translate}} <b>{{ totalWellPercentage - 100 }}%</b></ng-container>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</ng-container>

		<div *ngIf="NContribution.canSaveWellsAsPlantingDefault
				&& fn.UseWells.value
				&& totalWellPercentage === 100"
			class="bk-dialog__checkbox-options">
			<input type="checkbox"
				class="bk-dialog__checkbox"
				formControlName="ShouldSaveWellsAsPlantingDefault"
				name="ShouldSaveWellsAsPlantingDefault" />
			<label class="bk-dialog__checkbox--label">
				{{ "Save these well percentages as this planting's default" | translate }}
			</label>
		</div>

		<ng-container *ngIf="!fn.UseWells.value">
			<mat-form-field appearance="fill">
				<mat-label>
					{{ 'Water N Concentration' | translate }}:
				</mat-label>
				<input matInput
					type="number"
					step="0.01"
					min="0"
					name="PPMTotal"
					formControlName="PPMTotal"
					(ngModelChange)="calculateNContribution(true)"/>
				<span matSuffix class="mat-form-field-suffix--padded">
					{{'ppm' | translate}}
				</span>
			</mat-form-field>
		</ng-container>

		<div class="bk-n-contribution-ui__well--divider">
		</div>

		<div class="bk-n-contribution-ui__row">
			<div class="bk-n-contribution-ui__rec-irrigation">
				<label class="bk-n-contribution-ui__label">
					{{ 'Recommended Irrigation Amount' | translate }}
				</label>
				<div class="bk-n-contribution-ui__value--container">
					<div class="bk-n-contribution-ui__value">
						<ng-container *ngIf="irrigationUnit === 1">
							{{f.IrrigationRecommendation.value | number: '1.0-2'}}
						</ng-container>

						<ng-container *ngIf="irrigationUnit === 2">
							{{NContribution.recommendationHours}}
						</ng-container>
					</div>
					<div *ngIf="irrigationUnit === 1"
						class="bk-n-contribution-ui__unit">
						{{'Inches' | translate}}
					</div>
					<div *ngIf="irrigationUnit === 2"
						class="bk-n-contribution-ui__unit">
						{{'hours' | translate}}
					</div>
					<i [popper]="recommendedIrrigationPopper"
						[popperTrigger]="'click'"
						[popperPlacement]="'top'"
						[popperTimeoutAfterShow]="10000"
						class="bk-n-contribution-ui__tooltip-icon fa fa-info-circle"></i>
				</div>
			</div>
			<div class="bk-button-set bk-n-contribution-ui__button-set">
				<button class="bk-button bk-button-set__button bk-unit-menu__button bk-button--gray-icon"
					[ngClass]="{'bk-button-set__button--selected': irrigationUnit === 1}"
					type="button"
					(click)="setIrrigationUnit(1)">
					{{'Inches' | translate }}
				</button>
				<button class="bk-button bk-button-set__button bk-unit-menu__button bk-button--gray-icon"
					[ngClass]="{'bk-button-set__button--selected': irrigationUnit === 2}"
					type="button"
					(click)="setIrrigationUnit(2)">
					{{'Hours' | translate }}
				</button>
			</div>
		</div>

		<div class="bk-n-contribution-ui__row">
			<div class="bk-n-contribution-ui__rec-irrigation">
				<mat-form-field appearance="fill"> 
					<mat-label>
						{{ 'Calculate Contribution for' | translate }}:
					</mat-label>
					
					<input matInput *ngIf="irrigationUnit === irrigationUnits.INCHES"
						class="bk-modal__field bk-n-contribution-ui__input--short"
						type="number"
						step="0.01"min="0" 
						formControlName="IrrigationAmount"/>

					<input matInput *ngIf="irrigationUnit === irrigationUnits.HOURS"
						class="bk-modal__field bk-n-contribution-ui__input--short"
						type="number"
						step="0.1"
						min="0" 
						formControlName="irrigationAmountHours"/>

					<span matSuffix>
						<span class="bk-n-contribution-ui__unit"
							*ngIf="irrigationUnit === irrigationUnits.INCHES">
							{{'Inches' | translate}}
						</span>
						<span class="bk-n-contribution-ui__unit"
							*ngIf="irrigationUnit === irrigationUnits.HOURS">
							{{'hours' | translate}}
						</span>
					</span>
					<mat-error *ngIf="fn.IrrigationAmount.invalid && (fn.IrrigationAmount.dirty ||
						fn.IrrigationAmount.touched)">
						{{'Irrigation amount cannot be empty' | translate}}
					</mat-error>
				</mat-form-field>
			</div>
		</div>

		<div class="bk-n-contribution-ui__well--divider"></div>

		<label class="bk-n-contribution-ui__label">
			{{ 'N Contribution From Water' | translate }}
		</label>
		<div class="bk-n-contribution-ui__value--container">
			<div class="bk-n-contribution-ui__value"
				*ngIf="units === nUnits.LB_PER_ACRE">
				{{f.NAppliedFromWater.value | number: '1.0-2'}}
			</div>
			<div class="bk-n-contribution-ui__value"
				*ngIf="units === nUnits.FERTILIZER">
				{{getNAppliedFromWaterInFertilizerUnits() | number: '1.0-2'}}
			</div>
			<div class="bk-n-contribution-ui__unit"
				*ngIf="units === nUnits.LB_PER_ACRE">
				lbs N/{{'acre' | translate}}
			</div>
			<div class="bk-n-contribution-ui__unit"
				*ngIf="units === nUnits.FERTILIZER">
				<span *ngIf="f.IsFormulationTypeDry.value">
					{{'lbs' | translate }}/{{'acre' | translate }}
				</span>
				<span *ngIf="!f.IsFormulationTypeDry.value">
					{{'gal' | translate }}/{{'acre' | translate }}
				</span>
			</div>
			<i [popper]="nContributionPopper"
				[popperTrigger]="'click'"
				[popperPlacement]="'top'"
				[popperTimeoutAfterShow]="5000"
				class="bk-n-contribution-ui__tooltip-icon fa fa-info-circle">
			</i>
		</div>
	</div>
</form>

<popper-content #recommendedIrrigationPopper>
    <div class="bk-popper">
        <div class="bk-popper__header">
            {{ 'Recommended Irrigation Amount' | translate }}:
        </div>
        <div class="bk-popper__subheader">
            <span>
                {{ 'From' }} {{ (f && f.EventDate.value) | date:'shortDate' }} 
            </span>
            <span>
                {{ 'to' | translate }} {{ NContribution.nextFertilizationDate | date:'shortDate' }} 
                ({{ 'next planned fertilization' | translate }})
            </span>
        </div>
        <table class="bk-popper__table">
            <tr>
                <td class="bk-popper__column-1">
                    {{ 'Recommended Irrigation Amount' | translate }}:
                </td>
                <td class="bk-popper__column-2">
                    <ng-container *ngIf="irrigationUnit === irrigationUnits.INCHES">
                        {{ (f && f.IrrigationRecommendation.value) | number: '1.0-2' }} {{ 'Inches' | translate }}
                    </ng-container>
                    <ng-container *ngIf="irrigationUnit === irrigationUnits.HOURS">
                        {{ NContribution.recommendationHours }} {{ 'Hours' | translate }}
                    </ng-container>
                </td>
            </tr>
        </table>
    </div>
</popper-content>

<popper-content #nContributionPopper>
    <div class="bk-popper">
        <div class="bk-popper__header">
            {{ 'N Contribution From Water' | translate }}:
        </div>
        <table class="bk-popper__table">
            <tr>
                <td class="bk-popper__column-1">
                    {{ 'Expected Irrigation Amount' | translate }}:
                </td>
                <td class="bk-popper__column-2">
                    <ng-container *ngIf="irrigationUnit === 1 && fn && fn.IrrigationAmount">
                        {{ fn.IrrigationAmount.value | number: '1.0-2' }} {{ 'Inches' | translate }}
                    </ng-container>
                    <ng-container *ngIf="irrigationUnit === 2 && fn && fn.irrigationAmountHours">
                        {{ fn.irrigationAmountHours.value }} {{ 'Hours' | translate }}
                    </ng-container>
                </td>
            </tr>
            <tr>
                <td class="bk-popper__column-1">
                    {{ 'Avg Water N Concentration' | translate }}:
                </td>
                <td class="bk-popper__column-2">
                    <ng-container *ngIf="fn && !fn.UseWells.value">
                        {{ (fn && fn.PPMTotal.value) | number: '1.0-2' }} ppm
                    </ng-container>
                    <ng-container *ngIf="fn && fn.UseWells.value">
                        {{ NContribution.calculatedPPM | number: '1.0-2' }} ppm
                    </ng-container>
                </td>
            </tr>
            <tr>
                <td class="bk-popper__column-1">
                    {{ 'Total N Contribution From Water' | translate }}:
                </td>
                <td class="bk-popper__column-2">
                    <ng-container *ngIf="units === nUnits.LB_PER_ACRE">
                        {{ (f && f.NAppliedFromWater.value) | number: '1.0-2' }} lbs N/{{'acre' | translate}}
                    </ng-container>
                    <ng-container *ngIf="units === nUnits.FERTILIZER">
                        {{getNAppliedFromWaterInFertilizerUnits() | number: '1.0-2'}}
                        <span *ngIf="f && f.IsFormulationTypeDry.value">
                            {{'lbs' | translate }}/{{'acre' | translate }}
                        </span>
                        <span *ngIf="f && !f.IsFormulationTypeDry.value">
                            {{'gal' | translate }}/{{'acre' | translate }}
                        </span>
                    </ng-container>
                </td>
            </tr>
        </table>
    </div>
</popper-content>